export { default } from './global-state';
